import React from 'react';
import env from '@ludovicm67/react-dotenv';
import { Box, Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Settings } from '@mui/icons-material';
import logo from 'src/assets/logo.png';
import './Maintenance.scss';

const message = env?.REACT_APP_FEATURE_FLAG_MAINTENANCE_MESSAGE;

const TriangleIcons = () => {
    return (
        <Grid container spacing={1} className="gear-icons">
            <Grid xs={6} className="left-gear">
                <Settings />
            </Grid>
            <Grid xs={6} className="right-gears">
                <Settings className="top-gear" />
                <Settings className="bottom-gear" />
            </Grid>
        </Grid>
    );
};

export default function Maintenance() {
    return (
        <Box id="maintenance-container">
            <Box id="logo-container">
                <img src={logo} alt="Lanter Logo" style={{ height: '75px', paddingBottom: '15px' }} />
            </Box>
            <Card id="maintenance-card">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} className="maintenance-grid">
                            <TriangleIcons />
                        </Grid>
                        <Grid xs={12} className="maintenance-grid">
                            <Typography variant="h4">We are currently undergoing maintenance.</Typography>
                        </Grid>
                        <Grid xs={12} className="maintenance-grid">
                            <Typography variant="h5">{message ? message : 'Please check back later.'}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
}
